import { Grid, SearchPanel, Table, TableHeaderRow, Toolbar, VirtualTable } from '@devexpress/dx-react-grid-material-ui';
import { IntegratedFiltering, SearchState } from '@devexpress/dx-react-grid';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { actions } from './WorkOrderSerialNumber.redux';
import { Card } from 'antd';
import CopyTableDataToClipboard from '@/components/CopyTableDataToClipboard/copyTableDataToClipboard';
import { getTableColumnExtensions } from '../../../../lib/reactiveGridTableMethods'
import LoadingCover from '@/components/LoadingCover';
import { modifyTableData } from '../../../../components/CopyTableDataToClipboard/modifyTableData'
import { useParams } from 'react-router-dom';

const snSummaryListColumns = [
	{
		title: 'SN',
		name: 'U_TS_Allocated_Serial',
		width: '120px',
	},
	{
		title: 'Route',
		name: 'U_TS_WO_RS_Name',
		width: '350px',
	},
	{
		title: 'Status',
		name: 'Status',
		width: '150px',
	},
	{
		title: 'Notes',
		name: 'U_TS_WO_RS_Note',
		width: '400px',
	},
	{
		title: 'Data As Needed',
		name: 'U_TS_WO_RS_DataAsNeeded',
	},
]


const WorkOrderSNSummary = () => {
	const dispatch      = useDispatch(),
		  params        = useParams(),
		  docNum        = params.docNum,
		  loading       = useSelector(state => state.workOrderSerialNum.snSummaryLoading),
		  searchString  = useSelector(state => state.workOrderSerialNum.snSummarySearchString),
		  snSummaryList = useSelector(state => state.workOrderSerialNum.snSummaryList);
	
	useEffect(() => {
		if (docNum) {
			dispatch(actions.loadWorkOrderSNSummary(docNum));
		}
	}, [ dispatch, docNum ]);

	const setSearchValue = (value) => {
        if(loading) {
            return false;
        }
        dispatch(actions.setState({ snSummarySearchString: value }));
    };

	const RowComponent = (props) => {
        return (
			<Table.Row
				key={props.tableRow.rowId}
				{...props}
			/>
        );
    };

	const CellComponent = (props) => {
		return (
			<Table.Cell {...props} />
		)
	}

    return (
		<Card
			className="ts_portal_card ts-portal-card-margin ts-portal-card-top"
			title="Serial Number Summary"
		>

			{
				loading &&
				<LoadingCover />
			}

			{
				<Grid
					className="ts_content_height"
					rows={snSummaryList}
					columns={snSummaryListColumns}
				>
					<SearchState
                        onValueChange={setSearchValue}
                        value={searchString}
                    />

					<IntegratedFiltering />

					<VirtualTable
						cellComponent={CellComponent}
						rowComponent={RowComponent}
						columnExtensions={getTableColumnExtensions(snSummaryListColumns)}
					/>

					<TableHeaderRow />

					<Toolbar />

					<CopyTableDataToClipboard
						totalRows={snSummaryList.length}
						tableDataAsList={modifyTableData(snSummaryListColumns, snSummaryList)}
					/>

					<SearchPanel />
				</Grid>
			}

		</Card>

    );
};

export default WorkOrderSNSummary;
